export default (function (value) {
  return typeof value === 'string';
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-actions/es/utils/isString.js
// module id = ./node_modules/redux-actions/es/utils/isString.js
// module chunks = 6 9 11